module.exports = __webpack_public_path__ + "images/173_2048.jpg";